import styled from '@emotion/styled';

const ContentWrapper = styled('section')(({ theme }) => ({
  transition: theme.transitions.create('all'),
}));

export default ContentWrapper;
